import { Label } from "@radix-ui/react-label";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ConfigurationField } from "../../types";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/v2/select";

export function SelectField({
  field,
  disabled,
}: {
  field: Extract<ConfigurationField, { type: "select" }>;
  disabled?: boolean;
}) {
  const { setValue, watch } = useFormContext();
  const { t } = useTranslation();
  const value = watch(field.key);

  const placeholder = field.placeholder?.startsWith("integrations.")
    ? t(field.placeholder)
    : field.placeholder || "Select an option";

  return (
    <div className="space-y-2">
      <Label htmlFor={field.key} className="text-base">
        {t(field.label)}
        {field.required && <span className="text-destructive ml-1">*</span>}
      </Label>
      <Select
        value={value ?? ""}
        onValueChange={(val) => setValue(field.key, val)}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {field.options["select-options"].map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
